// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1xvRM","header":"PatientQuestionnaire_header__2qWSY","info":"PatientQuestionnaire_info__vb67W"};